import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getMemberRewards, isEmptyArray, LoadingState } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useMemberRewards } from '../../hooks/use-member-rewards';
import { Button, ButtonColor, ButtonSize } from '../../subcomponents/button';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { MemberRewardListCarousel } from './subcomponents/carousel';
import { MemberRewardListGrid } from './subcomponents/grid';
import { MemberRewardListMessage, MemberRewardListMessageType } from './subcomponents/message';
import { MemberRewardListSkeleton } from './subcomponents/skeleton';
import { MemberRewardListActionButtonMode } from './types/action-button-mode';
import { MemberRewardListContextInstance } from './types/context';
import { MemberRewardListMode } from './types/mode';
import { defaultMemberRewardListProps, memberRewardListPropsValidator } from './types/props';
import { sortRewards } from './utils/sort-rewards';
const b = bemClassBuilder('v-member-reward-list');
export const MemberRewardList = observer(props => {
    const { config, displayText, events } = props;
    const { loadingState } = useMemberRewards();
    if (loadingState === LoadingState.Failure) {
        return (_jsx(MemberRewardListContextInstance.Provider, Object.assign({ value: props }, { children: _jsx(MemberRewardListMessage, { messageType: MemberRewardListMessageType.FailedToLoadData }) })));
    }
    const memberRewards = getMemberRewards();
    if (!memberRewards) {
        return (_jsx(MemberRewardListContextInstance.Provider, Object.assign({ value: props }, { children: _jsx(MemberRewardListSkeleton, {}) })));
    }
    const sortedRewards = sortRewards(memberRewards, props.config);
    if (isEmptyArray(sortedRewards)) {
        return (_jsx(MemberRewardListContextInstance.Provider, Object.assign({ value: props }, { children: _jsx(MemberRewardListMessage, { messageType: MemberRewardListMessageType.NoRewards }) })));
    }
    return (_jsx(MemberRewardListContextInstance.Provider, Object.assign({ value: props }, { children: _jsxs("div", Object.assign({ className: b.block() }, { children: [config.mode === MemberRewardListMode.Carousel ? (_jsx(MemberRewardListCarousel, { rewards: sortedRewards })) : (_jsx(MemberRewardListGrid, { rewards: sortedRewards })), config.actionButton.show && config.actionButton.mode === MemberRewardListActionButtonMode.Basic && (_jsx(Button, { className: b.element('action-button'), label: displayText.actionButtonLabel, color: ButtonColor.Primary, size: ButtonSize.Large, onClick: events.onActionButtonClicked }))] })) })));
});
MemberRewardList.displayName = 'MemberRewardList';
/**
 * The **Member Reward List** component renders the rewards available to a Loyalty member. Rewards are redeemables that entitle the member to goods, services, or discounts.
 */
export const MemberRewardListComponent = withComponentWrapper(MemberRewardList, defaultMemberRewardListProps, memberRewardListPropsValidator);
